<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">医疗服务套餐列表</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<!-- <div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">全部</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">待完成</div>
							<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">已完成</div> -->
						</div>
						<div class="tabLineR">
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:180px;margin-right: 10px;" placeholder="请输入套餐名称" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">宠物类别</div>
							<el-select style="width:120px" v-model="search.categoryName" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:''},{label:'犬类',value:'犬类'},{label:'猫类',value:'猫类'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column align="center" label="套餐名称" prop="title">
							</el-table-column>
							<el-table-column label="分类" prop="title" width="200">
								<template slot-scope="props">
									{{props.row.category_info.name}}
								</template>
							</el-table-column>
							<el-table-column label="适用宠物" width="200">
								<template slot-scope="props">
									<span v-if="props.row.applyType==='2'">犬用</span>
									<span v-else-if="props.row.applyType==='1'">猫用</span>
									<span v-else>通用</span>
								</template>
							</el-table-column>
							<el-table-column label="价格" prop="total_money" width="200">
							</el-table-column>
							<el-table-column label="操作" width="200">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tabIndex:0,
				search:{
					"categoryName": '',  // 类型：犬类；猫类
					keyword:'',
				},
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			ylfwParams(){
				return this.$store.state.yiliaoxin.ylfwParams;
			},
		},
		beforeRouteEnter(to,from,next){
			next(vm=>{
				if(vm.page.page===1){
					vm.getTableData();
				}
			})
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// 返回
			back(){
				this.ylfwParams.type = 'list'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
			},
			toSee(row){
				this.ylfwParams.curRow_package = row
				this.ylfwParams.type = 'packageSee'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
			},
			reset(){
				this.search = {
					"categoryName": '',  // 类型：犬类；猫类
					keyword:'',
				},
				this.page.page=1;
				this.getTableData1()
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 切换列表
			changeTabIndex(index){
				this.tabIndex=index;
				if(index==0){
					this.search.serviceStatus = -1;
				}else if(index==1){
					this.search.serviceStatus = 1;
				}else if(index==2){
					this.search.serviceStatus = 2;
				}
				this.page.page=1;
				this.getTableData()
			},
			getTableData(){
				let applytype = ''
				if(this.search.categoryName===''){
					applytype = ''
				}else if(this.search.categoryName==='猫类'){
					applytype = '0,1'
				}else if(this.search.categoryName==='犬类'){
					applytype = '0,2'
				}
				let params = {
					"applytype": applytype,
					keyword: this.search.keyword,
					categoryId: '604323824335a2f958dc7410,604323834335a2f958dc7411,60544f91a8300a06f3f66864,60546e8b0b69e10e27f8f15e',
					"shopId": this.curShopId,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_Url2+'api/product/group/service/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
